package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.px

// SECTIONS ET BOÎTES DE CARROUSEL
val LettreCarouselContainerStyle = CssStyle {
    base {
        Modifier
            .height((390 + 120).px)
            .margin(top = 80.px, bottom = 120.px)
            .styleModifier {
                property("--card-width", "260px")
                property("--card-height", "390px")
                property("--card-gap", "25px")
                property("--visible-cards", "1")
            }
    }
    Breakpoint.MD {
        Modifier
            .height((400 + 120).px)
            .styleModifier {
                property("--card-width", "300px")
                property("--card-height", "400px")
                property("--card-gap", "35px")
                property("--visible-cards", "2")
            }
    }
    Breakpoint.LG {
        Modifier
            .height((480 + 120).px)
            .styleModifier {
                property("--card-width", "340px")
                property("--card-height", "480px")
                property("--card-gap", "50px")
                property("--visible-cards", "3")
            }
    }
}

val LettreCarouselTrackStyle = CssStyle {
    base {
        Modifier.styleModifier {
            property("height", "var(--card-height)")
            property("gap", "var(--card-gap)")
        }
    }
}

val LettreCarouselViewportStyle = CssStyle {
    base {
        // 1 carte visible: 260px
        Modifier
            .width(260.px)
            .height((390 + 40).px)
            .styleModifier {
                property("width", "calc(var(--visible-cards) * var(--card-width) + (var(--visible-cards) - 1) * var(--card-gap))")
                property("height", "calc(var(--card-height) + 40px)")
            }
    }
    Breakpoint.MD {
        // 2 cartes visibles: 300px * 2 + gap 35px = 635px
        Modifier
            .width(635.px)
            .height((400 + 40).px)
    }
    Breakpoint.LG {
        // 3 cartes visibles: 340px * 3 + gap(50px) * 2 = 1120px
        Modifier
            .width(1120.px)
            .height((480 + 40).px)
    }
}

// CARTE DE LETTRE
val CoverLetterCardStyle = CssStyle {
    base {
        Modifier
            .width(260.px)
            .height(390.px)
    }
    Breakpoint.MD {
        Modifier
            .width(300.px)
            .height(400.px)
    }
    Breakpoint.LG {
        Modifier
            .width(340.px)
            .height(480.px)
    }
    cssRule(":hover .cover-letter-btn") {
        Modifier.opacity(0.83)
    }
}

// BOUTONS CHEVRON
//val ChevronButtonStyle = CssStyle {
//    base { Modifier.size(40.px) }
//    Breakpoint.MD { Modifier.size(50.px) }
//}

val ChevronButtonIconStyle = CssStyle {
    base { Modifier.fontSize(24.px) }
    Breakpoint.MD { Modifier.fontSize(32.px) }
}

// BOUTON ACTION HOVER SUR LA CARTE
val CoverLetterButtonTextStyle = CssStyle {
    base { Modifier.fontSize(16.px) }
    cssRule(" span") {
        Modifier.styleModifier { property("font-size", "inherit") }
    }
}

val CoverLetterCardButtonStyle = CssStyle {
    base {
        Modifier
            .width(150.px)
            .height(40.px)
            .opacity(0)
            .styleModifier { property("transition", "opacity 200ms ease-in-out") }
    }

    // Affichage permanent sur appareils tactiles (mobiles/tablettes)
    cssRule("@media (hover: none)") {
        Modifier.opacity(0.83)
    }
}

val CoverLetterCardContainerStyle = CssStyle {
    // Au survol de la carte (sur desktop), le bouton devient visible
    cssRule(":hover .cover-letter-btn") {
        Modifier.opacity(0.83)
    }
}